// removed by extract-text-webpack-plugin
module.exports = {"Container":"roomViewer__Container__3Ds7C","Thumbnails":"roomViewer__Thumbnails__1FfqV","Aside":"roomViewer__Aside__1FC8H","ChatSection":"roomViewer__ChatSection__qK10-","Chat":"roomViewer__Chat__2KisA","AttendanceSection":"roomViewer__AttendanceSection__F264K","Title":"roomViewer__Title__2Ndks","Slider":"roomViewer__Slider__1PHuX","SliderOn":"roomViewer__SliderOn__2aB5h roomViewer__Slider__1PHuX"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Monitoring/roomViewer.css
// module id = 1649
// module chunks = 2